<template>
  <div class="item-repertory-component mt-4 w-100 " ref="content">
    <div
      :class="{ 'p-3': !isMyRepertory }"
      class="custom-card d-flex flex-column position-relative h-100"
    >
      <div v-if="isMyRepertory" class="d-flex align-items-center pb-3">
        <div class="number">
          {{ ind }}
        </div>
        <div class="flex-fill"></div>
        <button
          @click="exclude"
          class=" btn btn-header d-flex align-items-center"
        >
          <img
            class="mr-2"
            src="@/assets/images/repertories/delete.svg"
            alt="Deletar"
          />
          Remover
        </button>
      </div>
      <div class="custom-header" :class="{ 'px-3': isMyRepertory }">
        <h4>{{ music.name }}</h4>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center mb-3">
            <div class="d-flex align-items-center mr-4">
              <i class="mr-2 i" :class="`${iconMusicType}`"></i>
              <p class="mt-1 desc mb-0 text-capitalize">
                {{ musicType(music.type) }}
              </p>
            </div>
            <div class="d-flex align-items-center">
              <i class="i mr-2" :class="`${iconIntensity}`"></i>
              <p class="mt-1 mb-0 desc text-capitalize">
                {{ musicIntensity(music.intensity) }}
              </p>
            </div>
          </div>
          <div v-if="music.stream">
            <button
              @click="openModalIframe(music.stream)"
              class="btn bg-success ball p-3 d-flex aling-items-center justify-content-center"
            >
              <i class="icon-controller-play ml-1"></i>
            </button>
          </div>
        </div>
        <div class="d-flex align-items-center flex-wrap mb-4">
          <i class="icon-queue-music i mr-2 mt-1"></i>
          <p
            class="mt-1 mb-0 mr-1"
            v-for="(theme, index) in music.themes"
            :key="theme.id"
          >
            {{ theme.name }}
            <span v-if="index < music.themes.length - 1">•</span>
          </p>
        </div>
        <div class="line"></div>
        <div v-if="music.tone.name" class="d-flex align-items-center my-4">
          <p class="mb-0 chord">Tom:</p>
          <h3>{{ music.tone.name }}</h3>
        </div>
        <div v-if="music.tone.name" class="line"></div>
      </div>
      <div :class="{ 'px-3': isMyRepertory }" class="custom-body  mt-3 mb-5">
        <div
          class="d-flex flex-column justify-content-center align-items-start h-100 text-left"
        >
          <p class="my-0" v-if="music.author">
            <span class="text-grey">Artista:</span> {{ music.author.name }}
          </p>
          <p class="my-0" v-if="music.composers">
            <span class="text-grey">Compositor:</span> {{ music.composers }}
          </p>
          <p class="my-0" v-if="music.original_name">
            <span class="text-grey">Nome Original:</span>
            {{ music.original_name }}
          </p>
          <p class="my-0" v-if="music.versions.length > 0">
            <span class="text-grey">Versões:</span> {{ music.versions[0] }}
          </p>
          <p class="my-0" v-if="music.references">
            <span class="text-grey">Referências bíblicas:</span>
            {{ music.references }}.
          </p>
        </div>
      </div>
      <div class="flex-fill"></div>
      <div
        v-if="!isMyRepertory"
        :class="{ 'px-3 pb-3': isMyRepertory }"
        class="custom-footer  d-flex align-items-center"
      >
        <div class="flex-fill">
          <repertory-input :music="music" />
        </div>
        <!-- <button class="btn btn-success">Salvar</button> -->
      </div>
    </div>
    <!-- <div class="d-flex justify-content-center">
      <div
        v-if="music"
        class="row bg-item py-3 align-items-center w-100 mx-lg-0"
        :class="{ 'bg-item-active': selected }"
      >
        <div class="col-lg-7 pl-3">
          <div
            class="d-flex align-items-center justify-content-between pl-0 mx-lg-3"
          >
            <button
              class="d-flex align-items-center"
              @click="changeValueSelected"
            >
              <div
                class="mr-2 mb-1 d-flex align-items-center justify-content-center"
                :class="{
                  'border-img': !selected,
                  'bg-active': selected
                }"
              >
                <i
                  :class="{ 'icon-checkmark': selected }"
                  class="icon-size"
                ></i>
              </div>
              <h3 class="text-uppercase my-0">
                {{ music.name }}
              </h3>
            </button>
            <button
              class="p-2 d-lg-none"
              @click="responsiveMusicClose = !responsiveMusicClose"
              v-if="selected"
            >
              <div :class="{ 'invert-icon': responsiveMusicClose }">
                <i class="icon-arrow_drop_down icon-size"></i>
              </div>
            </button>
          </div>
          <div class="row py-3 align-items-center" v-if="responsiveMusicClose">
            <div class="col-lg-2">
              <div class="d-flex align-items-center mx-lg-3">
                <i class="mr-2" :class="`${iconMusicType}`"></i>
                <p class="mt-1 mb-0 text-capitalize">
                  {{ musicType(music.type) }}
                </p>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="d-flex align-items-center mx-lg-3">
                <i class="icon-calm mr-2"></i>
                <p class="mt-1 mb-0 text-capitalize">
                  {{ musicIntensity(music.intensity) }}
                </p>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="d-flex align-items-center flex-wrap">
                <i class="icon-queue-music mr-2 mt-1"></i>
                <p
                  class="mt-1 mb-0 mr-1"
                  v-for="(theme, index) in music.themes"
                  :key="theme.id"
                >
                  {{ theme.name }}
                  <span v-if="index < music.themes.length - 1">•</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-lg-1 border-right"
          :class="{ 'border-left': music.tone.name }"
          v-if="responsiveMusicClose"
        >
          <div
            v-if="music.tone.name"
            class="d-flex flex-lg-column justify-content-lg-between align-items-center"
          >
            <small class="pb-2">
              Tom:
            </small>
            <h4 class="pt-lg-4 pl-2 pl-lg-0">
              {{ music.tone.name }}
            </h4>
          </div>
          <div v-else class="py-lg-5"></div>
        </div>

        <div class="col-lg-4" v-if="responsiveMusicClose">
          <div
            class="d-flex flex-column justify-content-center align-items-start h-100 text-left"
          >
            <p class="my-0" v-if="music.author">
              <span class="text-grey">Autor:</span> {{ music.author.name }}
            </p>
            <p class="my-0" v-if="music.original_name">
              <span class="text-grey">Nome Original:</span>
              {{ music.original_name }}
            </p>
            <p class="my-0" v-if="music.versions.length > 0">
              <span class="text-grey">Versões:</span> {{ music.versions[0] }}
            </p>
            <p class="my-0" v-if="music.references">
              <span class="text-grey">Referências bíblicas:</span>
              {{ music.references }}.
            </p>
          </div>
        </div>
      </div>
    </div> -->
    <modal-iframe v-model="showModal" :src="src" />
  </div>
</template>

<script>
import RepertoryInput from "./RepertoryInput.vue";
import ModalIframe from "./ModalIframe.vue";
export default {
  components: { RepertoryInput, ModalIframe },
  data() {
    return {
      selected: this.select,
      iconMusicType: "",
      iconIntensity: "",
      showModal: false,
      src: ""
    };
  },
  props: {
    music: {
      type: Object,
      default: () => {}
    },
    select: {
      typeof: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 1
    },
    isMyRepertory: {
      type: Boolean,
      default: false
    },
    disabled: {
      typeof: Boolean,
      default: false
    },
    idRepertory: {
      type: Boolean,
      default: true
    },
    responsiveMusicClose: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    changeValueSelected() {
      if (this.disabled) return;

      if (!this.idRepertory) {
        this.$message.warning("Selecione um Repertório");
      } else {
        this.selected = !this.selected;
        if (this.selected) {
          this.$emit("selected", this.music);
        } else {
          this.$emit("deselected");
        }
      }
    },
    musicType(typeMusic) {
      switch (typeMusic) {
        case "anthem":
          this.iconMusicType = "icon-Cross";
          return "Hino";
        case "chant":
          this.iconMusicType = "icon-church";
          return "Cântico";
        case "music":
          this.iconMusicType = "icon-mic";
          return "Música";
      }
    },
    musicIntensity(intensityMusic) {
      switch (intensityMusic) {
        case "1":
          this.iconIntensity = "icon-calm";
          return "Calma";
        case "2":
          this.iconIntensity = "icon-medium";
          return "Média";
        case "3":
          this.iconIntensity = "icon-icon-intensity";
          return "Agitada";
      }
    },
    exclude() {
      this.$emit("excludeItem");
    },
    openModalIframe(link) {
      this.src = this.getEmbedUrl(link);
      this.showModal = true;
    },
    getEmbedUrl(url) {
      if (url.includes("embed")) {
        return url;
      }
      if (url.includes("youtube")) {
        return url.replace("watch?v=", "/embed/");
      }
      if (url.includes("spotify")) {
        return url.replace("track", "embed/track");
      }

      return url;
    }
  },
  computed: {
    ind() {
      return this.index + 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.item-repertory-component {
  .custom-card {
    background: #111112;
    border-radius: 6px;

    .line {
      widows: 100%;
      height: 2px;
      background: #2c2c2c;
    }

    .number {
      background: #2db563;
      border-radius: 6px 0px 6px 0px;
      padding: 12px 15px;
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 29px;
      display: flex;
      align-items: center;
      text-align: center;
      text-transform: uppercase;

      color: #ffffff;
    }

    .btn-header {
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 130%;
      transition: filter 1s;
      &:hover {
        filter: brightness(80%);
      }
    }

    .custom-header {
      h4 {
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 150%;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: #2db563;
        text-align: left;
      }

      i {
        font-size: 20px;
      }

      .desc {
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 130%;
      }

      .chord {
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 140%;
        color: #8b8b8b;
      }

      h3 {
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 150%;
        color: #ffffff;
      }
    }

    .custom-body {
      p {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 140%;
        margin-bottom: 8px;

        span {
          font-weight: 700;
        }
      }
    }

    .custom-footer {
      .btn-success {
        background: #2db563;
        border-radius: 6px;
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 130%;
        color: #ffffff;
        padding-inline: 24px;
        transition: filter 1s;

        &:hover {
          filter: brightness(0.8);
        }
      }
    }
  }
  .icon-size {
    font-size: 10px;
  }

  .text-grey {
    color: #8b8b8b;
  }

  .bg-item {
    background: #111112;
    border-radius: 6px;
    transition: 0.4s;
    &:hover {
      transform: scale(1.02);
      filter: brightness(130%);
    }
  }

  .border-right {
    border-right: 2px solid #2c2c2c !important;
  }

  .border-left {
    @media screen and (max-width: 992px) {
      border-left: none !important;
      border-right: none !important;
    }
    border-top: none !important;
    border-bottom: none !important;
    border-left: 2px solid #2c2c2c !important;
  }

  .bg-item-active {
    border: 1px solid #2db563;
    background: linear-gradient(
        0deg,
        rgba(45, 181, 99, 0),
        rgba(45, 181, 99, 0)
      ),
      linear-gradient(0deg, #111112, #111112)
        linear-gradient(0deg, #2db563, #2db563);
  }

  button {
    background: none;
    border: none;
    color: #ffffff;
  }

  h3 {
    color: #2db563;
    @media screen and (max-width: 768px) {
      font-size: 18px;
    }
  }

  p {
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
  }

  .border-img,
  .bg-active {
    border: 1px solid #2db563;
    border-radius: 50%;
    width: 20px;
    height: 20px;
  }

  .ball {
    border-radius: 50%;
  }

  .bg-active {
    background-color: #2db563;
    border: none;
  }

  .invert-icon {
    transform: rotate(180deg);
  }
}
</style>
